import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=3adeded8&scoped=true&"
import script from "./imgs.vue?vue&type=script&lang=js&"
export * from "./imgs.vue?vue&type=script&lang=js&"
import style0 from "./imgs.vue?vue&type=style&index=0&id=3adeded8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adeded8",
  null
  
)

export default component.exports